import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=4644b6be&scoped=true"
import script from "./ProfileView.vue?vue&type=script&lang=js"
export * from "./ProfileView.vue?vue&type=script&lang=js"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=4644b6be&prod&scoped=true&lang=scss"
import style1 from "./ProfileView.vue?vue&type=style&index=1&id=4644b6be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4644b6be",
  null
  
)

export default component.exports